import type { Address } from "viem"
import type { Config } from "wagmi"

import type { EmitEvent } from "@/domains/core"
import type { IEventBus } from "@/domains/events"
import type { EventEmitter } from "@/domains/library"
import type { TransactionReturnType } from "@/domains/on-chain"
import { ManualClFeesCollectedEvent } from "@/domains/thick-v1/events"

import { collectFeesFromThickNfpPosition } from "@/domains/on-chain/transactions/thick-v1/collect-fees-from-thick-nfp"

/**
 * Collect-fees interaction for a thick-v1 position.
 *
 * Emits `ManualClFeesCollectedEvent` on success.
 */
export interface CollectFeesFromThickNfpInteractionParams {
  account: Address
  chainId: number
  config: Config
  tokenId: bigint
  poolAddress: Address
  nfpManagerAddress: Address
  emitter: EventEmitter<EmitEvent>
  eventBus: IEventBus
}

export const collectFeesFromThickNfpInteraction = async ({
  account,
  chainId,
  config,
  tokenId,
  poolAddress,
  nfpManagerAddress,
  emitter,
  eventBus,
}: CollectFeesFromThickNfpInteractionParams): Promise<TransactionReturnType> => {
  const result = await collectFeesFromThickNfpPosition({
    account,
    chainId,
    config,
    tokenId,
    nfpManagerAddress,
  })

  if (result.success) {
    emitter.emit("collect-fees-from-thick-nfp", {
      title: "Collected fees",
      variant: "success",
    })
    eventBus.publish(
      new ManualClFeesCollectedEvent({
        poolAddress,
        tokenId,
        transactionHash: "tx" in result ? result.tx : undefined,
      }),
    )
    return result
  }

  emitter.emit("collect-fees-from-thick-nfp", {
    title: "Unable to collect fees",
    description: "error" in result ? result.error : undefined,
    variant: "error",
  })

  return result
}
